export enum enumChargesDistributionType {
  PREPAID,
  COLLECT,
}
